(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents) => {
    const fmt = (window.b0ng && window.b0ng.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* Age gate */
  const gate = $('#AgeGate');
  if (gate && store.get('b0ng_age_ok') !== '1' && !navigator.webdriver) {
    gate.classList.add('is-visible');
    document.documentElement.style.overflow = 'hidden';
    $('[data-age-yes]', gate).addEventListener('click', () => {
      store.set('b0ng_age_ok', '1');
      gate.classList.remove('is-visible');
      document.documentElement.style.overflow = '';
    });
  }

  /* Mobile nav */
  const toggle = $('[data-menu-toggle]'), mnav = $('#MobileNav');
  if (toggle && mnav) {
    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = mnav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', (e) => { if (!mnav.contains(e.target)) mnav.classList.remove('is-open'); });
  }

  /* Filters toggle (mobile) */
  $$('[data-filters-toggle]').forEach(b => b.addEventListener('click', () => { const f = $('#Filters'); if (f) f.classList.toggle('is-open'); }));

  /* Wishlist (local only) */
  const wish = new Set(JSON.parse(store.get('b0ng_wish') || '[]'));
  $$('[data-wish]').forEach(btn => {
    if (wish.has(btn.dataset.wish)) btn.setAttribute('aria-pressed', 'true');
    btn.addEventListener('click', () => {
      const h = btn.dataset.wish;
      wish.has(h) ? wish.delete(h) : wish.add(h);
      btn.setAttribute('aria-pressed', wish.has(h));
      store.set('b0ng_wish', JSON.stringify([...wish]));
    });
  });

  /* Cart drawer */
  const drawer = $('#CartDrawer');
  const openDrawer = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); };
  const closeDrawer = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); };
  const esc = (s) => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* Free-shipping upsell: cheapest $9.50–$15 item that closes the gap (candidates from cart-drawer.liquid) */
  let upsellPool = null;
  const renderUpsell = (cart) => {
    const slots = $$('[data-ship-upsell-slot]');
    if (!slots.length) return;
    if (upsellPool === null) {
      try { upsellPool = JSON.parse(($('[data-ship-upsell]') || {}).textContent || '[]'); } catch (e) { upsellPool = []; }
    }
    const inCart = new Set((cart.items || []).map(it => it.product_id));
    slots.forEach(slot => {
      const th = parseInt(slot.dataset.threshold, 10) || 0;
      const gap = th - cart.total_price;
      const pick = (th > 0 && gap > 0 && cart.item_count > 0)
        ? upsellPool.filter(c => !inCart.has(c.id) && c.price >= gap).sort((a, b) => a.price - b.price)[0]
        : null;
      if (!pick) { slot.hidden = true; slot.innerHTML = ''; return; }
      slot.innerHTML = `
        ${pick.image ? `<a class="ship-upsell__img" href="${esc(pick.url)}"><img src="${esc(pick.image)}" alt="" width="56" height="56" loading="lazy"></a>` : ''}
        <p class="ship-upsell__msg">Add <a href="${esc(pick.url)}">${esc(pick.title)}</a> (${money(pick.price)}) and unlock free shipping.</p>
        <form method="post" action="${esc(window.b0ng.routes.cart_add)}" data-add-to-cart${'reload' in slot.dataset ? ' data-reload' : ''}>
          <input type="hidden" name="id" value="${pick.variant_id}">
          <input type="hidden" name="quantity" value="1">
          <button class="btn btn--green btn--sm" type="submit">Add</button>
        </form>`;
      slot.hidden = false;
    });
  };

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    renderUpsell(cart);
    if (!drawer) return;
    $('[data-cart-total]', drawer).textContent = money(cart.total_price);
    const saved = $('[data-cart-saved]', drawer);
    if (saved) { saved.hidden = !(cart.total_discount > 0); saved.querySelector('span:last-child').textContent = '−' + money(cart.total_discount); }
    const ship = $('[data-free-ship]', drawer);
    const th = parseInt(ship.dataset.threshold, 10) || 0;
    if (th > 0) {
      const left = th - cart.total_price;
      const pct = Math.min(100, (cart.total_price / th) * 100);
      ship.innerHTML = (left > 0 ? `You're <strong>${money(left)}</strong> away from free shipping.` : `<strong>You've unlocked free shipping!</strong>`) + `<div class="drawer__bar"><span style="width:${pct}%"></span></div>`;
    } else ship.hidden = true;
    const items = $('[data-cart-items]', drawer);
    if (!cart.items.length) { items.innerHTML = '<p style="text-align:center;padding:2rem 0">Your stash is empty.</p>'; return; }
    items.innerHTML = cart.items.map((it, i) => `
      <div class="line">
        ${it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=160" alt="">` : '<span></span>'}
        <div>
          <a class="line__title" href="${it.url}">${esc(it.product_title)}</a>
          ${it.product_has_only_default_variant ? '' : `<div class="line__meta">${esc(it.variant_title || '')}</div>`}
          <div class="line__meta">Qty ${it.quantity}</div>
          ${(it.line_level_discount_allocations || []).map(d => `<div class="line__deal">${esc(d.discount_application.title.includes('Deal of the Day') ? 'Deal of the Day' : d.discount_application.title)}: −${money(d.amount)}</div>`).join('')}
          <button class="line__remove" data-remove="${i + 1}">Remove</button>
        </div>
        <strong class="line__price">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}${money(it.final_line_price)}</strong>
      </div>`).join('');
  };
  const fetchCart = () => fetch(window.b0ng.routes.cart + '.js').then(r => r.json()).then(renderCart);

  if (drawer) {
    $$('[data-drawer-close]', drawer).forEach(el => el.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });
    $$('[data-cart-open]').forEach(a => a.addEventListener('click', (e) => {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); fetchCart().then(openDrawer);
    }));
    drawer.addEventListener('click', (e) => {
      const line = e.target.closest('[data-remove]');
      if (!line) return;
      fetch(window.b0ng.routes.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +line.dataset.remove, quantity: 0 }) })
        .then(r => r.json()).then(renderCart);
    });
  }

  /* Full cart page: show the upsell on load */
  if ($('.cart-page [data-ship-upsell-slot]')) fetch(window.b0ng.routes.cart + '.js').then(r => r.json()).then(renderUpsell).catch(() => {});

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-add-to-cart]');
    if (!form || !drawer) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fetch(window.b0ng.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(r => r.json().then(j => ({ ok: r.ok, j })))
      .then(({ ok, j }) => {
        if (!ok) throw new Error(j.description || 'Could not add to cart');
        if ('reload' in form.dataset) { location.reload(); return new Promise(() => {}); }
        return fetchCart();
      })
      .then(openDrawer)
      .catch(err => alert(err.message))
      .finally(() => { btn.disabled = false; btn.textContent = label; });
  });

  /* Product page: gallery, qty, variants */
  $$('[data-thumb]').forEach(t => t.addEventListener('click', () => {
    const img = $('[data-main-media] img');
    if (img) { img.srcset = ''; img.src = t.dataset.thumb; img.alt = t.dataset.alt; }
    $$('[data-thumb]').forEach(x => x.removeAttribute('aria-current'));
    t.setAttribute('aria-current', 'true');
  }));
  $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (+input.value || 1) + (+b.dataset.qty));
  }));
  const pform = $('[data-product-form]');
  const vjson = pform && $('[data-variants]', pform);
  if (vjson) {
    const variants = JSON.parse(vjson.textContent);
    pform.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-input]')) return;
      const sel = $$('fieldset.option', pform).map(fs => (fs.querySelector('input:checked') || {}).value);
      const v = variants.find(v => v.options.every((o, i) => o === sel[i]));
      const btn = $('[data-add-button]', pform);
      const price = $('[data-price]');
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      $('[data-variant-id]', pform).value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      price.innerHTML = `<span>${money(v.price)}</span>` + (v.compare_at_price > v.price ? `<s>${money(v.compare_at_price)}</s>` : '');
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_image) { const img = $('[data-main-media] img'); if (img) { img.srcset = ''; img.src = v.featured_image.src; } }
    });
  }
})();

/* Deal of the Day countdown: time left until midnight America/New_York. */
(() => {
  const els = document.querySelectorAll('[data-midnight]');
  if (!els.length) return;
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' });
  const pad = (n) => String(n).padStart(2, '0');
  let last = null;
  const tick = () => {
    const parts = Object.fromEntries(fmt.formatToParts(new Date()).map((p) => [p.type, p.value]));
    const left = 86400 - ((+parts.hour % 24) * 3600 + (+parts.minute) * 60 + (+parts.second));
    if (last !== null && left > last) { location.reload(); return; } // midnight passed: load the new deal
    last = left;
    const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
    els.forEach((el) => {
      el.querySelector('[data-h]').textContent = pad(h);
      el.querySelector('[data-m]').textContent = pad(m);
      el.querySelector('[data-s]').textContent = pad(s);
    });
  };
  tick(); setInterval(tick, 1000);
})();

/* Deal expiry date in ET (keeps cached pages accurate). */
(() => {
  const els = document.querySelectorAll('[data-deal-date]'); if (!els.length) return;
  const d = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'long', month: 'long', day: 'numeric' }).format(new Date());
  els.forEach((el) => { el.textContent = d; });
})();

/* Predictive search: suggestions under the header and mobile-nav search inputs. */
(() => {
  const inputs = [...document.querySelectorAll('form[role="search"] input[name="q"]')];
  if (!inputs.length || !window.fetch) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) => {
    const fmt = (window.b0ng && window.b0ng.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  };
  const img = (u, w) => u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '';
  let uid = 0;

  inputs.forEach((input) => {
    const form = input.form;
    form.classList.add('psearch-host');
    const box = document.createElement('div');
    const id = 'PSearch-' + (++uid);
    box.className = 'psearch'; box.id = id; box.hidden = true; box.setAttribute('role', 'listbox');
    form.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-expanded', 'false');
    let timer = null, ctrl = null, active = -1;

    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    const open = () => { box.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const links = () => [...box.querySelectorAll('a')];
    const setActive = (i) => {
      const l = links(); if (!l.length) return;
      active = (i + l.length) % l.length;
      l.forEach((a, n) => a.classList.toggle('is-active', n === active));
      l[active].scrollIntoView({ block: 'nearest' });
    };

    const render = (q, res) => {
      const r = (res && res.resources && res.resources.results) || {};
      const products = r.products || [], cols = r.collections || [], arts = r.articles || [];
      const all = `${root}search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
      let html = '';
      if (products.length) {
        html += '<p class="psearch__h">Products</p>' + products.map(p => {
          const src = img((p.featured_image && p.featured_image.url) || p.image, 120);
          const cents = Math.round(parseFloat(p.price) * 100);
          return `<a class="psearch__prod" href="${esc(p.url)}">${src ? `<img src="${esc(src)}" alt="" width="44" height="44" loading="lazy">` : '<span class="psearch__ph"></span>'}<span class="psearch__t">${esc(p.title)}</span>${isNaN(cents) ? '' : `<span class="psearch__p">${esc(money(cents))}</span>`}</a>`;
        }).join('');
      }
      if (cols.length) html += '<p class="psearch__h">Collections</p>' + cols.map(c => `<a class="psearch__link" href="${esc(c.url)}">${esc(c.title)}</a>`).join('');
      if (arts.length) html += '<p class="psearch__h">Articles</p>' + arts.map(a => `<a class="psearch__link" href="${esc(a.url)}">${esc(a.title)}</a>`).join('');
      if (!html) html = `<p class="psearch__none">No matches for “${esc(q)}”. mrb0ng is still looking.</p>`;
      html += `<a class="psearch__all" href="${esc(all)}">See all results for “${esc(q)}” →</a>`;
      box.innerHTML = html; active = -1; open();
    };

    const run = () => {
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection,article&resources[limit]=6&resources[options][unavailable_products]=hide`;
      fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(r => r.ok ? r.json() : null)
        .then(j => { if (input.value.trim() === q) render(q, j); })
        .catch(() => {});
    };

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 200); });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { close(); return; }
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); links()[active].click(); }
    });
    box.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); input.focus(); } });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  });
})();
